import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "order-status-container-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "order-status-container order-in-progress d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_3 = { class: "countDown" }
const _hoisted_4 = { class: "order-in-progress__title text-center" }
const _hoisted_5 = { class: "order-in-progress__text" }
const _hoisted_6 = {
  key: 1,
  class: "order-status-container order-completed d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_7 = { class: "order-in-progress__title text-center" }
const _hoisted_8 = { class: "order-in-progress__text" }
const _hoisted_9 = { class: "countDown" }
const _hoisted_10 = {
  key: 2,
  class: "order-status-container order-failed d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_11 = { class: "order-in-progress__title text-center" }
const _hoisted_12 = { class: "order-in-progress__text" }
const _hoisted_13 = {
  key: 3,
  class: "order-status-container order-completed d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_14 = { class: "order-in-progress__title text-center" }
const _hoisted_15 = { class: "order-in-progress__text" }
const _hoisted_16 = { class: "countDown" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.name === _ctx.routesConst.ORDER_IN_PROGRESS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "loader" }, null, -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.countDownOrderInProgress) + " s.", 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('order_in_progress')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('please_wait')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$route.name === _ctx.routesConst.ORDER_COMPLETED)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "icon" }, [
            _createElementVNode("img", {
              src: "/assets/images/check-circle-success.png",
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('order_payment_successful')), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('order_info_sent_to_email')), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('redirecting')) + " " + _toDisplayString(_ctx.countDownOrderCompleted) + " s.", 1),
          _createVNode(_component_ButtonComponent, {
            class: "order-status-form-button",
            onClick: _withModifiers(_ctx.redirectToCustomerPurchaseHistory, ["prevent"])
          }, {
            btnContent: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$route.name === _ctx.routesConst.ORDER_FAILED)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "icon" }, [
            _createElementVNode("img", {
              src: "/assets/images/times-failed.png",
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('order_progress_failed')), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('please_try_again')), 1),
          _createVNode(_component_router_link, {
            to: '/' + _ctx.routesConst.ORDER
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ButtonComponent, { class: "order-status-form-button" }, {
                btnContent: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('try_again')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$route.name === _ctx.routesConst.ORDER_REGISTERED)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "icon" }, [
            _createElementVNode("img", {
              src: "/assets/images/check-circle-success.png",
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('order_registered')), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('order_info_sent_to_email')), 1),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('redirecting')) + " " + _toDisplayString(_ctx.countDownOrderCompleted) + " s.", 1),
          _createVNode(_component_ButtonComponent, {
            class: "order-status-form-button",
            onClick: _withModifiers(_ctx.redirectToCustomerPurchaseHistory, ["prevent"])
          }, {
            btnContent: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}